import ActionTypes from "../Actions/ActionTypes";
import { getUnlinkAssets } from "../Actions/AssetsAction";

let initialState = {
  getCusDashboard: [],
  getCusAssets: [],
  assetsDetail: null,
  setCusAssetsStatus: null,
  getCusUnlinkAssets: [],
};

const CusAssetsReducer = (state = initialState, action) => {
  // console.log("statee", state);

  switch (action.type) {
    case ActionTypes.GET_CUS_DASHBOARD:
      state = { ...state, getCusDashboard: action.payload };
      break;
    case ActionTypes.GET_CUS_ASSETS:
      state = { ...state, getCusAssets: action.payload };
      break;
    case ActionTypes.GET_CUS_ASSET_DETAIL:
      state = { ...state, assetsDetail: action.payload };
      break;
    case ActionTypes.SET_CUS_ASSETS_STATUS:
      state = { ...state, setCusAssetsStatus: action.payload };
      break;
    case ActionTypes.CUS_GET_UNLINK_ASSETS:
      state = { ...state, getCusUnlinkAssets: action.payload };
      break;
    default:
      break;
  }
  return state;
};

export default CusAssetsReducer;
